import {
  AUTH_SIGN_IN,
  AUTH_SIGN_UP,
  AUTH_LOG_OUT,
  AUTH_SET_ERROR,
  AUTH_SET_PENDING,
  AUTH_SET_USERDATA,
  AUTH_SET_PRICETYPE,
  AUTH_SET_USERTYPE,
  AUTH_SET_USER_OPTION,
} from './actionTypes';
import { successToast, errorToast } from 'configuration/notifications';
import { userApi } from 'helpers/api/user';

export const Auth = {
  signIn: (creditnals) => async (dispatch) => {
    dispatch(Auth.pendingAction(true));

    try {
      const { data } = await userApi.signIn(creditnals);
      successToast('Вы успешно авторизовались в системе');
      dispatch(Auth.signInAction(data));
    } catch (error) {
      errorToast('Ошибка при входе в систему');
      dispatch(Auth.authErrorAction(error));
    }
  },

  signUp: (creditnals) => async (dispatch) => {
    dispatch(Auth.pendingAction(true));

    try {
      const { data } = await userApi.signUp(creditnals);
      successToast('Вы успешно зарегистрировались в системе');
      dispatch(Auth.signUpAction(data));
    } catch (error) {
      errorToast('Ошибка при входе в систему');
      dispatch(Auth.authErrorAction(error));
    }
  },

  getUserOption: () => async (dispatch) => {
    userApi.getUserOption().then(({ data } = {}) => {
      dispatch(Auth.setUserOptionAction(data));
    });
  },

  setUserOption: (data) => async (dispatch) => {
    userApi.setUserOption(data).then(({ data } = {}) => {
      dispatch(Auth.setUserOptionAction(data));
    });
  },

  getUserTypeList: () => async (dispatch) => {
    dispatch(Auth.setUserType([]));
    userApi.getUserTypeList().then(({ data } = {}) => {
      dispatch(Auth.setUserType(data));
    });
  },

  getPriceTypesList: () => async (dispatch) => {
    dispatch(Auth.setPriceType([]));

    userApi.getPriceTypeList().then(({ data } = {}) => {
      dispatch(Auth.setPriceType(data));
    });
  },

  setCashBox: (cashbox) => async (dispatch) => {
    userApi.setCashbox({ cashboxes: [cashbox] }).then(({ data } = {}) => {
      dispatch(Auth.setUserDataAction({ ...data }));
    });
  },

  setStock: (stock) => async (dispatch) => {
    userApi.setStock({ defaultStockID: stock }).then(({ data } = {}) => {
      dispatch(Auth.setUserDataAction({ ...data }));
    });
  },

  setOrg: (org) => async (dispatch) => {
    userApi.setOrg({ defaultOrgID: org }).then(({ data } = {}) => {
      dispatch(Auth.setUserDataAction({ ...data }));
    });
  },

  logOut: ({ showToast } = { showToast: true }) => (dispatch) => {
    dispatch(Auth.logoutAction());
    showToast && successToast('Вы успешно вышли из системы!');
  },

  setPriceType: (payload) => ({
    type: AUTH_SET_PRICETYPE,
    payload,
  }),

  setUserType: (payload) => ({
    type: AUTH_SET_USERTYPE,
    payload,
  }),

  signInAction: (payload) => ({
    type: AUTH_SIGN_IN,
    payload,
  }),

  signUpAction: (payload) => ({
    type: AUTH_SIGN_UP,
    payload,
  }),

  authErrorAction: (payload) => ({
    type: AUTH_SET_ERROR,
    payload,
  }),

  pendingAction: (payload) => ({
    type: AUTH_SET_PENDING,
    payload,
  }),

  logoutAction: (payload) => ({
    type: AUTH_LOG_OUT,
    payload,
  }),

  setUserDataAction: (payload) => ({
    type: AUTH_SET_USERDATA,
    payload,
  }),

  setUserOptionAction: (payload) => ({
    type: AUTH_SET_USER_OPTION,
    payload,
  }),
};
